import i18next from 'i18next';

import { exportPastMix } from '../exports/export';
import ExportPastMixByStoreModal from '../exports/ExportPastMixByStoreModal';

export const getActions = ({
  exportData,
  useTtc,
  currency,
  storeName,
  startDate,
  endDate,
  selectedStores,
  openSmallModal,
}) => [
  {
    label: i18next.t('FORECAST.PAST_MIX.EXPORT_ACTION'),
    icon: `/images/inpulse/file-download-black-small.svg`,
    handleClick: () => {
      if (!exportData) {
        return;
      }

      exportPastMix({
        data: exportData,
        useTtc,
        currency,
        clientStoreName: storeName,
        startDate,
        endDate,
        stores: selectedStores,
      });
    },
  },
  {
    label: i18next.t('FORECAST.PAST_MIX.EXPORT_BY_STORE_ACTION'),
    icon: `/images/inpulse/file-download-black-small.svg`,
    handleClick: () =>
      openSmallModal({
        component: ExportPastMixByStoreModal,
        currency,
        context: {
          stores: selectedStores,
          startDate,
          endDate,
        },
      }),
  },
];
